import { deleteBasketItems } from 'utils/basket';
import { logEvent, queueBasketUpdate } from '../helpers';

function isBasketDeleteProductsEvent(e: Event): e is CustomEvent<(string | { code: string, quantity: number })[]> {
  if ('detail' in e) {
    return Array.isArray(e.detail) && (typeof e.detail[0] === 'string' || (typeof e.detail[0] === 'object' && typeof e.detail[0].code === 'string' && typeof e.detail[0].quantity === 'number'));
  }
  return false;
}

export const handleBasketDeleteProducts = (e: Event) => {
  if (isBasketDeleteProductsEvent(e)) {
    logEvent('basket:delete_products', e.detail);
    queueBasketUpdate((basket) => {
      const ids = e.detail;

      return deleteBasketItems(basket, ids);
    });
  } else {
    console.error('Invalid arguments in basket:delete_products event');
  }
};
